const GatewayTab = {
  ANALYTICS: "analytics",
  SETTINGS: "settings",
};

export default GatewayTab;
